import { LoaderName } from '../../redux/loading/types'

export const getLoadingCarouselName = (id: number) => `${LoaderName.LOAD_CAROUSEL}-${id}`
